import { Frame } from 'stompjs'
import { message } from 'antd'
import { ImportAssetWebSocket } from './ImportAssetWebSocket'
import { NotifyWebSocket } from '../../../common-notify/web-socket-model-notify'
import store from '../../../store'
import { UpdateNotifySuccessEvent } from '../../../authorization-module/people/state-event'
import { AddNotifyWebSocketSuccessEvent } from '../../../common-notify/state-event'

function onImportAssetEvent(frame: Frame) {
    console.log(JSON.parse(frame.body))
    const event: NotifyWebSocket = JSON.parse(frame.body)
    console.log(event)
    if (event.httpStatus.toString() === '202') {
        console.log('checking TenantService Uploaded')
    } else if (event.httpStatus.toString() === '429') {
        if (event) {
            const data = JSON.parse(JSON.stringify(event.responseData))
            message.error(data?.messageFail)
        }
    } else {
        store.dispatch(UpdateNotifySuccessEvent.build(store.getState().notify + 1))
        store.dispatch(AddNotifyWebSocketSuccessEvent.build(event))
    }
}

let isSubscribed = false
export const ImportAssetWebSocketChannel = {
    subscribe: (email:string) => {
        if (!isSubscribed) {
            ImportAssetWebSocket.getClient()
                .then((client) => {
                    client.subscribe(ImportAssetWebSocket.buildDestinationImportAsset(`${email}/importAsset`), onImportAssetEvent)
                    isSubscribed = true
                })
                .catch((_err) => {
                // message.error(`Failed web socket connection. ${err}`)
                })
        }
    }
}
